import { Typography } from "@material-ui/core"
import { withStyles } from "@material-ui/core/styles"

export const TitleTextBold = withStyles({
    root: {
        color: "#FFFFFF",
        fontWeight: "bold"
    }
})(Typography);
